import React, { useEffect, useState } from 'react'
import { checkwithremovemonth, fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'
import { ToastContainer } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../_metronic/i18n/Tr'
import PriceInput from '../components/PriceInput'

function PointSystem() {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()

  interface UpgradedTask {
    title: string
    value: string
  }

  interface BadgeData {
    degrees: string
    badges: string
    upgradedtasks: UpgradedTask[]
    reward: string
    recognition: string
    // Add other properties as needed
  }

  const [data, setData] = useState<BadgeData[]>([])

  const [adminData, setAdminData] = useState(Object)
  const [pointSystemList, setPointSystemList] = useState([
    { loyaltysettingId: '', point: '', availability: '', amount: '', compare: '' },
  ])
  const [reviewsList, setReviewsList] = useState([])
  const [explorePostList, setExplorePostList] = useState([])
  const [bonusList, setBonusList] = useState([])
  const [error, setError] = useState(Object)
  const [amount, setAmount] = useState("") as any
  const [point, setPoint] = useState("")
  const [loading, setLoading] = useState(false)
  const [bookingLoading, setBookingLoading] = useState(false)

  useEffect(() => {
    document.title = 'Insayr | Point System'
    var store: any = sessionStorage.getItem('admin')
    setAdminData(JSON.parse(store))
  }, [])


  const removeError = (err: any) => {
    // Ensure error is an array before spreading
    var tmp = Array.isArray(error) ? [...error] : [{}]
    // Ensure the first object exists
    if (!tmp[0]) tmp[0] = {}

    tmp[0][err] = '' // Clear the specific error key
    setError(tmp)
  }


  const addbookingrow = async () => {
    var tmp: any = [
      ...pointSystemList,
      { id: '', point: 0, availability: 0, amount: 0, equal: 'Grater Than Equal to' },
    ]
    setPointSystemList(tmp)
  }
  const removebookingrow = async (index: any) => {
    var tmp: any = pointSystemList.filter((item: any, ind: any) => ind != index)
    setPointSystemList(tmp)
  }

  const onchange = (column: any, value: any, index: any) => {
    var tmp: any = [...pointSystemList]
    tmp[index][column] = checkwithremovemonth(value, tmp[index][column])
    setPointSystemList(tmp)
  }

  // call API start
  const selectLoyaltySettingAPICall = async () => {
    var param = {}
    var res = await fetchData('admin/selectLoyaltySetting', param)
    if (res.status == 200) {
      var tmp = res.data
        .filter((item: any) => item.type == 'Reviews')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
          }
        })
      setReviewsList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Explore Posts')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
            badgesId: item.badgesId,
          }
        })
      setExplorePostList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Booking')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
            compare: item.compare,
          }
        })
      setPointSystemList(tmp)

      var tmp = res.data
        .filter((item: any) => item.type == 'Bonus')
        .map((item: any) => {
          return {
            loyaltysettingId: item.loyaltysettingId,
            point: item.point,
            amount: item.amount,
            availability: item.availability,
            label: item.label,
            compare: item.compare,
          }
        })
        .sort((a: any, b: any) => Number(a.amount) - Number(b.amount))
      setBonusList(tmp)
    } else {
      toasterrormsg(res.message)
    }
  }
  const getBadgeSystemList = async () => {
    try {
      const response = await fetchData('admin/getbadgesdetaillist', Object, 'GET')
      if (response.status === 200) {
        const badgesData = response.data.map((badge: any) => {
          // Ensure upgradedtasks is always an array
          const upgradedtasks = badge.upgradedtasks
            ? Array.isArray(badge.upgradedtasks)
              ? badge.upgradedtasks
              : Object.entries(badge.upgradedtasks).map(([key, value]) => ({
                title: key,
                value,
              }))
            : [{ title: '', value: '' }]
          return {
            ...badge,
            upgradedtasks,
            recognition: badge.recognition || '', // Initialize recognition
          }
        })
        setData(badgesData)
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }
  }

  const onSubmit = async (type: any) => {
    var param: any = {
      adminId: adminData['adminId'],
    }
    var API = 'admin/addUpdateBooking'

    if (type == 'booking') {
      param['type'] = 'Booking'
      param['response'] = pointSystemList
      setBookingLoading(true)
    } else if (type == 'review') {
      param['response'] = reviewsList
      API = 'admin/updateReviewReward'
    } else if (type == 'post') {
      param['response'] = explorePostList
      API = 'admin/updateReviewReward'
    }
    var res = await fetchData(API, param)
    if (res.status == 200) {
      if (type == 'booking') {
        param['type'] = 'Bonus'
        param['response'] = bonusList
        var res = await fetchData(API, param)
        setBookingLoading(false)
        if (res.status == 200) {
          toastsuccessmsg('Success')
        } else {
          toasterrormsg(res.message)
        }
      } else {
        toastsuccessmsg('Success')
      }
    } else {
      if (type == 'booking') setBookingLoading(false)
      toasterrormsg(res.message)
    }
  }

  const validate = (data: any[]) => {
    for (let item of data) {
      // Check if any upgradedtasks value is empty

      // Check if reward is empty
      if (item.reward === '') {
        return false
      } else if (/^(0+)$/.test(item.reward)) {
        return false
      }
    }

    return true
  }

  const handleChange = (index: number, key: string, value: any, key2?: any) => {
    if (!/^\d*$/.test(value)) {
      return // Exit early if the value is not numeric
    }
    setData((prevData) => {
      const newData: any = [...prevData]
      if (key2 != null && key2 != '') {
        newData[index][key][key2] = value
      } else {
        newData[index][key] = value
      }

      return newData
    })
  }

  const onSubmit2 = async () => {
    let adminId = ''
    const adminDataString = sessionStorage.getItem('admin')

    if (adminDataString) {
      const adminData = JSON.parse(adminDataString)
      adminId = adminData.adminId
    }

    if (!validate(data)) {
      toasterrormsg('All Fields Are Requried')
      return // Exit early if validation fails
    }

    try {
      const param = {
        adminId: adminId,
        updateBadgesDetailData: data,
      }

      const res = await fetchData('admin/updatebadgesdetaillist', param)
      if (res.status === 200) {
        await onSubmit('post')
        getBadgeSystemList()
      } else {
        toasterrormsg(res.message)
      }
    } catch (error) {
      toasterrormsg('Failed to submit form')
    }
  }

  useEffect(() => {
    selectLoyaltySettingAPICall()
    getBadgeSystemList()
  }, [])


  const equivalencyDataApiCall = async () => {

    var res = await fetchData('admin/viewpointsequivalency ', {})

    if (res.status == '200') {
      var data = res.data
      setAmount(data.amount)
      setPoint(data.point)
    } else {
      toasterrormsg(res.message)
    }
  }


  // validate Equivalency upload
  const validateEquivalency = () => {
    let isValid = true;
    let errorTmp = Array.isArray(error) ? [...error] : [{}]; // Ensure array

    // Reset error first
    errorTmp[0].amount = '';

    // Check empty
    if (!amount || String(amount).trim() === '') {
      errorTmp[0].amount = t('Amount is required');
      isValid = false;
    }
    // Check valid number (integer or decimal)
    else if (!/^\d+(\.\d+)?$/.test(String(amount))) {
      errorTmp[0].amount = t('Amount must be a valid number');
      isValid = false;
    }
    // Optional: ensure positive number
    else if (parseFloat(amount) <= 0) {
      errorTmp[0].amount = t('Amount must be greater than 0');
      isValid = false;
    }
    if (!amount || String(amount).trim() === '') {
      errorTmp[0].point = t('Point is required');
      isValid = false;
    }
    // Check valid number (integer or decimal)
    else if (!/^\d+(\.\d+)?$/.test(String(amount))) {
      errorTmp[0].point = t('Point must be a valid number');
      isValid = false;
    }
    // Optional: ensure positive number
    else if (parseFloat(amount) <= 0) {
      errorTmp[0].point = t('Point must be greater than 0');
      isValid = false;
    }

    setError(errorTmp);

    if (isValid) {
      saveEquivalency();
    }
  };

  //save equivalency api call
  const saveEquivalency = async () => {
    setLoading(true)

    const param = {
      point: point,
      adminId: adminData['adminId'],
      amount: amount,
    }

    var res = await fetchData('admin/savepointsequivalency', param)

    if (res.status == '200') {
      setLoading(false)

      equivalencyDataApiCall()
      toastsuccessmsg(res.message)
    } else {
      setLoading(false)
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    equivalencyDataApiCall()
  }, [])

  return (
    <>
      <ToastContainer />
      <div className='container'>
        <div className='row mt-5'>
          <div className="col-12">
            <label className="h3">{t("Points Equivalency")}</label>
          </div>

          <div className="row g-3 align-items-center mt-3">
            {/* First Input */}
            <div className="col-12 col-md-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Enter amount"
                value={point}
                onChange={(event: any) => {
                  setPoint(event.target.value);
                  removeError("point");
                }}
              />
              {error && error[0]?.point && (
                <label className="text-danger mt-1">{error[0].point}</label>
              )}
            </div>

            {/* Middle Text */}
            <div className="col-12 col-md-auto">
              <span className="fs-5 fw-bold">{t("Points equal to")}</span>
            </div>

            {/* Second Input */}
            <div className="col-12 col-md-auto mt-0">
              <PriceInput
                labelClass="fs-6 form-label "
                inputClass="form-control  border-right-0"
                placeholder={t("Enter Amount")}
                value={amount}
                onChange={(event: any) => {                  
                  setAmount(event);
                  removeError("amount");
                }}
              />
              {error && error[0]?.amount && (
                <label className="text-danger mt-1">{error[0].amount}</label>
              )}
            </div>

            {/* Currency */}


            {/* Save Button */}
            <div className="col-12 col-md-auto">
              <button
                type="button"
                disabled={loading}
                className="btn btn-success w-100 w-md-auto"
                onClick={validateEquivalency}
              >
                <span className="indicator-label">{t("Save")}</span>
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm mx-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </div>

          <hr />
          <div className='col-12'>
            <label className='h3'>{t('Booking')}</label>
          </div>
          <table className='table'>
            <thead>
              <tr>
                <th scope='col'></th>
                <th scope='col' className='fs-4 fw-bold'>
                  {t('Points')}
                </th>
                <th scope='col' className='fs-4 fw-bold'>
                  {t('Availability')}
                </th>
                <th scope='col'></th>
              </tr>
            </thead>
            <tbody>
              {pointSystemList.map((item: any, index: any) => {
                return (
                  <>
                    <tr>
                      <td>
                        <label className='d-inline-block'>
                          <span className='fs-4 fw-bold d-inline-block'>{t('For Every UZS')} </span>
                          <input
                            type='text'
                            className='form-control form-control-solid d-inline-block mw-150px'
                            placeholder='Amount'
                            value={item.amount}
                            onChange={(e: any) => {
                              const val = String(e.target.value ?? "");
                              if ((val && val.match(/^\d+$/)) || val === "") {
                                onchange(
                                  "amount",
                                  val.replace(/^0+(?=\d)/, "") || "0", // Keep as string
                                  index
                                );
                              }
                            }}
                          />
                          <span className='fs-4 fw-bold d-inline-block'> {t('or')} </span>{' '}
                          <select
                            className='form-select form-select-solid d-inline-block mw-150px'
                            defaultChecked={item.compare}
                            value={item.compare}
                            onChange={(e: any) => {
                              onchange('compare', e.target.value, index)
                            }}
                          >
                            <option value={'Grater Than Equal to'}>Grater Than Equal to</option>
                            <option value={'Equal to'}>Equal to</option>
                          </select>
                        </label>
                      </td>
                      <td>
                        <input
                          type='text'
                          className='form-control form-control-solid w-80px'
                          placeholder='Enter Point'
                          value={item.point}
                          onChange={(e: any) => {
                            onchange('point', e.target.value.replace(/^0+(?=\d)/, '') || 0, index)
                          }}
                        />
                      </td>
                      <td className='d-flex align-items-center'>
                        <input
                          type='text'
                          className='form-control form-control-solid w-80px'
                          placeholder='Availability'
                          value={item.availability}
                          onChange={(e: any) => {
                            onchange(
                              'availability',
                              e.target.value.replace(/^0+(?=\d)/, '') || 0,
                              index
                            )
                          }}
                        />
                        &nbsp;&nbsp;{' '}
                        <span className='fw-bold'>
                          {item.availability > 2 ? 'Months' : 'Month'}
                        </span>
                      </td>
                      <td>
                        {index > 0 && (
                          <button
                            className='btn btn-danger'
                            onClick={() => {
                              removebookingrow(index)
                            }}
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </button>
                        )}
                      </td>
                    </tr>
                  </>
                )
              })}

              <tr>
                <td colSpan={3}></td>
                <td>
                  <button
                    className='btn btn-success'
                    onClick={() => {
                      addbookingrow()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </td>
              </tr>
              {bonusList && bonusList.map((item: any, index: number) => (
                  <tr key={item.loyaltysettingId}>
                    <td>
                      <label className="d-inline-block">
                        <span className="fs-4 fw-bold d-inline-block">
                          {t(`${item.label} level members earn`)}
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-solid d-inline-block mw-80px"
                          placeholder="Amount"
                          value={item.amount ?? 0}
                          onChange={(e: any) => {
                            const val = e.target.value;
                            if ((/^\d+$/.test(val) || val === "") && Number(val) <= 100) {
                              const tmp: any = [...bonusList];
                              tmp[index] = {
                                ...tmp[index],
                                amount: val.replace(/^0+(?=\d)/, "") || 0,
                              };
                              setBonusList(tmp);
                            }
                          }}
                        />
                        <span className="fs-4 fw-bold d-inline-block">
                          {t("% more Points.")}
                        </span>
                      </label>
                    </td>
                  </tr>
                ))}

              <tr>
                <td colSpan={4} style={{ textAlign: 'right' }}>
                  {menuIdEdit ? <button
                    className='btn btn-success'
                    disabled={bookingLoading}
                    onClick={() => {
                      onSubmit('booking')
                    }}
                  >
                    <span className="indicator-label">{t('Save')}</span>
                    {bookingLoading && (
                      <span
                        className="spinner-border spinner-border-sm mx-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                  </button> : ""}
                </td>
              </tr>
            </tbody>
          </table>

          <hr />
          <div className='col-12'>
  <label className='h3'>{t('Reviews')}</label>
  <table className='table'>
    <thead>
      <tr>
        <th scope='col'></th>
        <th scope='col' className='fs-4 fw-bold'>{t('Points')}</th>
        <th scope='col' className='fs-4 fw-bold'>{t('Availability')}</th>
      </tr>
    </thead>
    <tbody>
      {reviewsList.map((review: any, index: number) => (
        <tr key={review.loyaltysettingId ?? index}>
          <td>
            <div className='fw-bold fs-5' dangerouslySetInnerHTML={{ __html: review.label }} />
          </td>
          <td>
            <input
              type='text'
              className='form-control form-control-solid w-80px'
              placeholder={t('Enter Point')}
              value={review.point}
              onChange={(e: any) => {
                var tmp: any = [...reviewsList]
                tmp[index]['point'] = checkwithremovemonth(e.target.value, tmp[index]['point'])
                setReviewsList(tmp)
              }}
            />
          </td>
          <td>
            <div className='d-flex align-items-center'>
              <input
                type='text'
                className='form-control form-control-solid w-80px'
                placeholder={t('Enter Availability')}
                value={review.availability}
                onChange={(e: any) => {
                  var tmp: any = [...reviewsList]
                  tmp[index]['availability'] = checkwithremovemonth(e.target.value, tmp[index]['availability'])
                  setReviewsList(tmp)
                }}
              />
              &nbsp;&nbsp;
              <span className='fw-bold'>
                {review.availability > 2 ? t('Months') : t('Month')}
              </span>
            </div>
          </td>
        </tr>
      ))}
      <tr>
        <td colSpan={3} style={{ textAlign: 'right' }}>
          {menuIdEdit && (
            <button className='btn btn-success' onClick={() => onSubmit('review')}>
              {t('Save')}
            </button>
          )}
        </td>
      </tr>
    </tbody>
  </table>
</div>
          {/* Reviews section end */}

          <hr />
          {/* Explore Posts section start */}
          <div className='col-12'>
            <label className='h3'>{t('Explore Posts')}</label>
            <div className="table-responsive mt-5">
              <table className="table">
                <thead>
                  <tr>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Badge Level')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Type')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Points')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Recognition')}
                    </th>
                    <th scope='col' className='fs-4 fw-bold'>
                      {t('Availability')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item: any, index: any) => {
                    const visibleTasks = item.upgradedtasks.filter((task: any) => task.title !== 'Complete Profile Details')
                    const taskCount = visibleTasks.length || 1
                    // Match explore post by badgesId instead of array index
                    const explorePostIndex = explorePostList.findIndex((ep: any) => ep.badgesId == item.badgesId)
                    const matchedExplorePost: any = explorePostIndex !== -1 ? explorePostList[explorePostIndex] : null
                    return (
                      <React.Fragment key={index}>
                        {/* Badge name header row */}
                        <tr className='border-0'>
                          <td className='pb-0 pt-6 border-0'>
                            <div className='fw-bold fs-4'>{item.badges}</div>
                          </td>
                          <td className='pb-0 pt-6 border-0'>
                            {index === 0 && <span className='fs-7'>{t("New Sign Up")}</span>}
                          </td>
                          <td rowSpan={index === 0 ? 1 : taskCount + 1} className='align-middle'>
                            <input
                              type='text'
                              className='form-control form-control-solid w-80px fw-bold'
                              placeholder='Enter Point'
                              value={item.reward}
                              onChange={(e) => handleChange(index, 'reward', e.target.value)}
                            />
                          </td>
                          <td rowSpan={index === 0 ? 1 : taskCount + 1} className='align-middle'>
                            <span className='fs-6 fw-bold'>
                              {index === 0 ? 'Badge' : item.recognition}
                            </span>
                          </td>
                          {index === 0 ? (
                            <td></td>
                          ) : (
                            <td rowSpan={taskCount + 1} className='align-middle'>
                              <div className='d-flex align-items-center'>
                                <input
                                  type='text'
                                  className='form-control form-control-solid w-80px'
                                  placeholder='Enter Availability'
                                  value={matchedExplorePost ? matchedExplorePost['availability'] : 0}
                                  onChange={(e: any) => {
                                    if (explorePostIndex !== -1) {
                                      var tmp: any = [...explorePostList]
                                      tmp[explorePostIndex]['availability'] = checkwithremovemonth(
                                        e.target.value,
                                        tmp[explorePostIndex]['availability']
                                      )
                                      setExplorePostList(tmp)
                                    }
                                  }}
                                />
                                &nbsp;&nbsp;
                                <span className='fw-bold'>
                                  {matchedExplorePost && matchedExplorePost['availability'] > 2
                                    ? t('Months')
                                    : t('Month')}
                                </span>
                              </div>
                            </td>
                          )}
                        </tr>
                        {/* Each task as its own row (skip for first badge) */}
                        {index > 0 && visibleTasks.map((task: any, taskIndex: number) => (
                          <tr key={taskIndex} className='border-0'>
                            <td className='py-3 border-0 align-middle'>
                              <span className='fs-6'>{task.title}</span>
                            </td>
                            <td className='py-3 border-0 align-middle'>
                              <span className='fw-bold fs-6'>{task.value}</span>
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ textAlign: 'right' }}>
              {menuIdEdit ? <button
                className='btn btn-success'
                onClick={() => {
                  onSubmit2()
                }}
              >
                {t('Save')}
              </button> : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PointSystem
